




























import { Component, Vue } from 'vue-property-decorator';
import MainHeader from '@/layouts/MainHeader.vue';
import MainMenu from '@/layouts/MainMenu.vue';
import MainContent from '@/layouts/MainContent.vue';
import { PreferencesAction } from '@/store/PreferencesModule';

@Component({
  components: { MainContent, MainMenu, MainHeader },
})
export default class LayoutMain extends Vue {
  mounted() {
    if (this.isDarkMode) {
      document.body.classList.add('dark-layout');
    } else {
      document.body.classList.remove('dark-layout');
    }
  }

  get isCollapsed() {
    return this.$store.getters[`PreferencesModule/isMenuCollapsed`];
  }
  get isCollapsedSetting() {
    return this.$store.getters[`PreferencesModule/isMenuCollapsedSetting`];
  }

  get isDarkMode(): boolean {
    return this.$store.getters['PreferencesModule/isDarkMode'];
  }

  get isMobileMenuExpanded() {
    return this.$store.getters[`PreferencesModule/isMobileMenuExpanded`];
  }
  async closeMobileMenu() {
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.expandMobileMenu}`, false);
  }
}
